module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.decorated.status_text === 'Cancelled' ? 'load-cancelled' : _vm.load.day
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2  col-md-1"
  }, [_c('p', {
    staticClass: "load-number"
  }, [_vm._v(_vm._s(_vm.number))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-sm-10 col-md-11"
  }, [_c('p', {
    staticClass: "load-reference"
  }, [_vm._v("\n        " + _vm._s(_vm.decorated.reference_number) + "\n        "), _c('span', {
    staticClass: "load-status pull-right",
    class: _vm.decorated.status_class
  }, [_vm._v(_vm._s(_vm.decorated.status_text))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-offset-2 col-sm-10 col-md-offset-1 col-md-11"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.decorated.loading_date) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.decorated.loading_time) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Weighbridge Details")]), _c('br'), _vm._v(" "), (_vm.haveWeighbridge) ? _c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-load-check"
    },
    on: {
      "click": _vm.setActiveLoad
    }
  }, [_vm._v("\n              View "), _c('i', {
    staticClass: "fa fa-external-link-square"
  })]) : _c('span', [_vm._v("–")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Net Weight")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.decorated.net_weight) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.$user.isCarrierOrDriver ? _vm.decorated.rate : _vm.jobDecorated.rate) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', {
    staticClass: "load-cost"
  }, [_c('strong', [_vm._v("Load Cost")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.clientChargeAsMoney) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-lg-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.load.notes) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Dockets")]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dockets ? _vm.dockets : '–')
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Rego:")]), _vm._v(" " + _vm._s(_vm.decorated.registration))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Load Size:")]), _vm._v(" " + _vm._s(_vm.decorated.size))])])])]), _vm._v(" "), (_vm.load.charges.length) ? _c('hr', {
    staticClass: "m-t-sm m-b-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.haveCharges) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10 col-md-offset-1 col-md-11"
  }, _vm._l((_vm.load.charges), function(charge) {
    return _c('charge', {
      key: charge.id,
      attrs: {
        "charge": charge,
        "load": _vm.load
      }
    })
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4f372e5a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/ClientLoad.vue
// module id = 997
// module chunks = 0